import { SVGProps, Ref, forwardRef } from 'react';

export const RadiusFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M10.667 2.667c0-.601.135-1.203.467-1.682C10.251.675 9.213.5 8 .5 2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5c0-1.069-.152-2.137-.5-3.119-.405.281-.95.452-1.667.452-.564 0-1.022-.106-1.389-.288l-1.57 1.571c.205.42.292.902.292 1.384 0 1.333-.666 2.666-2.666 2.666S5.333 9.333 5.333 8C5.333 6.666 6 5.333 8 5.333c.564 0 1.022.106 1.389.288l1.57-1.57c-.205-.42-.293-.902-.293-1.384"
                    fill="currentColor"
                />
                <path
                    d="M6.733 8c0-.459.117-.768.259-.937.104-.125.344-.33 1.008-.33.663 0 .903.205 1.008.33.141.17.258.478.258.937 0 .458-.117.767-.258.937-.105.125-.345.33-1.008.33-.664 0-.904-.205-1.008-.33-.142-.17-.259-.479-.259-.937"
                    fill="currentColor"
                />
                <path
                    d="M12.326 1.73c-.142.17-.26.478-.26.937s.118.767.26.937c.104.125.344.33 1.008.33.663 0 .903-.205 1.007-.33.142-.17.26-.478.26-.937s-.118-.767-.26-.937c-.104-.125-.344-.33-1.007-.33-.664 0-.904.205-1.008.33"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
RadiusFilledSize16Glyph.displayName = 'RadiusFilledSize16Glyph';
